(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products-video"] && !Shopify.designMode) return;
  try {
    
  class FeaturedProductsVideoCarousel {
    constructor(container) {
      this.container = container;
      this.scrollContainer = container.querySelector('.featured-products-video-style__scroll-container');
      this.prevBtn = container.querySelector('.featured-products-video-style__nav--prev');
      this.nextBtn = container.querySelector('.featured-products-video-style__nav--next');
      this.cards = container.querySelectorAll('.featured-products-video-style__card');
      this.modal = document.getElementById('productModal');

      this.init();
    }

    init() {
      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.addEventListener('click', () => this.scroll('prev'));
        this.nextBtn.addEventListener('click', () => this.scroll('next'));
      }

      // 初始化卡片视频悬停播放
      this.cards.forEach(card => {
        const video = card.querySelector('.featured-products-video-style__video');
        if (video) {
          card.addEventListener('mouseenter', () => {
            video.play();
          });
          card.addEventListener('mouseleave', () => {
            video.pause();
            video.currentTime = 0;
          });
        }

        // 点击卡片打开弹窗
        card.addEventListener('click', (e) => {
          e.preventDefault();
          this.openModal(card);
        });
      });

      // 关闭弹窗
      if (this.modal) {
        const closeBtn = this.modal.querySelector('.featured-products-video-style__modal-close');
        const overlay = this.modal.querySelector('.featured-products-video-style__modal-overlay');

        closeBtn.addEventListener('click', () => this.closeModal());
        overlay.addEventListener('click', () => this.closeModal());

        // ESC 键关闭
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.modal.classList.contains('active')) {
            this.closeModal();
          }
        });
      }

      // 更新导航按钮状态
      this.scrollContainer.addEventListener('scroll', () => this.updateNavButtons());
      this.updateNavButtons();
    }

    openModal(card) {
      const title = card.dataset.title;
      const price = card.dataset.price;
      const comparePrice = card.dataset.compare;
      const hasComparePrice = card.dataset.sale === '1';
      const description = card.dataset.desc;
      const imageUrl = card.dataset.productImage;
      const videoUrl = card.dataset.video;
      const productUrl = card.dataset.url;
      const vendor = card.dataset.vendor;
      const type = card.dataset.type;
      const available = card.dataset.available === 'true';
      const productId = card.dataset.productId;
      const hasOnlyDefaultVariant = card.dataset.hasVariants === 'true';

      // 填充弹窗内容
      document.getElementById('modalProductTitle').textContent = title;
      document.getElementById('modalCurrentPrice').textContent = price;
      document.getElementById('modalProductDescription').innerHTML = description;
      document.getElementById('modalViewDetails').href = productUrl;

      // 加载产品变体信息
      this.loadProductVariants(productId, hasOnlyDefaultVariant, productUrl);

      // 填充产品规格
      const vendorItem = document.getElementById('modalVendor');
      const vendorValue = document.getElementById('modalVendorValue');
      if (vendor && vendor.trim() !== '') {
        vendorValue.textContent = vendor;
        vendorItem.style.display = 'flex';
      } else {
        vendorItem.style.display = 'none';
      }

      const typeItem = document.getElementById('modalType');
      const typeValue = document.getElementById('modalTypeValue');
      if (type && type.trim() !== '') {
        typeValue.textContent = type;
        typeItem.style.display = 'flex';
      } else {
        typeItem.style.display = 'none';
      }

      const availabilityValue = document.getElementById('modalAvailabilityValue');
      availabilityValue.textContent = available ? 'In Stock' : 'Out of Stock';
      availabilityValue.style.color = available ? '#2e7d32' : '#d32f2f';

      // 处理视频或图片
      const modalVideo = document.getElementById('modalProductVideo');
      const modalImage = document.getElementById('modalProductImage');
      const modalVideoSource = document.getElementById('modalVideoSource');
      const playButton = document.getElementById('modalPlayButton');

      if (videoUrl) {
        // 有视频，显示视频
        modalVideoSource.src = videoUrl;
        modalVideo.load();
        modalImage.src = imageUrl;
        modalImage.style.display = 'block';
        modalVideo.style.display = 'none';
        modalVideo.classList.remove('playing');
        playButton.style.display = 'flex';

        // 点击播放按钮播放视频
        const playVideoHandler = () => {
          modalImage.style.display = 'none';
          modalVideo.style.display = 'block';
          modalVideo.classList.add('playing');
          modalVideo.play();
          playButton.style.display = 'none';
        };

        playButton.onclick = playVideoHandler;
      } else {
        // 没有视频，只显示图片
        modalImage.src = imageUrl;
        modalImage.alt = title;
        modalImage.style.display = 'block';
        modalVideo.style.display = 'none';
        playButton.style.display = 'none';
      }

      // 处理对比价格
      const comparePriceElement = document.getElementById('modalComparePrice');
      if (hasComparePrice) {
        comparePriceElement.textContent = comparePrice;
        comparePriceElement.style.display = 'inline';
      } else {
        comparePriceElement.style.display = 'none';
      }

      // 显示弹窗
      this.modal.style.display = 'flex';
      setTimeout(() => {
        this.modal.classList.add('active');
      }, 10);

      // 禁止body滚动
      document.body.style.overflow = 'hidden';
    }

    closeModal() {
      // 停止视频播放
      const modalVideo = document.getElementById('modalProductVideo');
      if (modalVideo) {
        modalVideo.pause();
        modalVideo.currentTime = 0;
      }

      this.modal.classList.remove('active');
      setTimeout(() => {
        this.modal.style.display = 'none';
      }, 300);

      // 恢复body滚动
      document.body.style.overflow = '';
    }

    scroll(direction) {
      const scrollAmount = this.scrollContainer.offsetWidth * 0.8;
      const currentScroll = this.scrollContainer.scrollLeft;

      if (direction === 'prev') {
        this.scrollContainer.scrollTo({
          left: currentScroll - scrollAmount,
          behavior: 'smooth'
        });
      } else {
        this.scrollContainer.scrollTo({
          left: currentScroll + scrollAmount,
          behavior: 'smooth'
        });
      }
    }

    updateNavButtons() {
      const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;

      if (this.prevBtn) {
        this.prevBtn.style.display = scrollLeft > 0 ? 'flex' : 'none';
      }

      if (this.nextBtn) {
        this.nextBtn.style.display = scrollLeft < scrollWidth - clientWidth - 10 ? 'flex' : 'none';
      }
    }

    async loadProductVariants(productId, hasOnlyDefaultVariant, productUrl) {
      const variantsContainer = document.getElementById('modalProductVariants');

      // 如果只有默认变体，不显示变体选择器
      if (hasOnlyDefaultVariant) {
        variantsContainer.innerHTML = '';
        return;
      }

      try {
        // 获取产品数据 - 从产品URL获取handle
        const productHandle = productUrl.split('/products/')[1].split('?')[0];
        const response = await fetch(`/products/${productHandle}.js`);
        const product = await response.json();

        if (!product.options || product.options.length === 0) {
          variantsContainer.innerHTML = '';
          return;
        }

        // 构建变体选择器HTML
        let variantsHTML = '';
        product.options.forEach((option, index) => {
          if (option.name === 'Title' && option.values.length === 1) {
            return; // 跳过默认的Title选项
          }

          variantsHTML += `
            <div class="featured-products-video-style__modal-variant-group">
              <label class="featured-products-video-style__modal-variant-label">${option.name}</label>
              <div class="featured-products-video-style__modal-variant-options" data-option-index="${index}">
          `;

          option.values.forEach(value => {
            const isSelected = index === 0 && value === option.values[0];
            variantsHTML += `
              <div class="featured-products-video-style__modal-variant-option ${isSelected ? 'selected' : ''}"
                   data-option-value="${value}">
                ${value}
              </div>
            `;
          });

          variantsHTML += `
              </div>
            </div>
          `;
        });

        variantsContainer.innerHTML = variantsHTML;

        // 添加变体选择事件
        const optionButtons = variantsContainer.querySelectorAll('.featured-products-video-style__modal-variant-option');
        optionButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            const parent = e.target.closest('.featured-products-video-style__modal-variant-options');
            parent.querySelectorAll('.featured-products-video-style__modal-variant-option').forEach(btn => {
              btn.classList.remove('selected');
            });
            e.target.classList.add('selected');
          });
        });

      } catch (error) {
        console.error('Error loading product variants:', error);
        variantsContainer.innerHTML = '';
      }
    }
  }

  // 初始化所有轮播
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.featured-products-video-style__carousel').forEach(carousel => {
      new FeaturedProductsVideoCarousel(carousel);
    });
  });

  // Shopify主题编辑器支持
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const carousel = event.target.querySelector('.featured-products-video-style__carousel');
      if (carousel) {
        new FeaturedProductsVideoCarousel(carousel);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
